<script setup>
   import { ref, watch, watchEffect, reactive, inject } from 'vue'
   import { modalHide } from '@/composables/bootstrap'
   import { generateID } from '@/composables/strings'
   import { SUBJECTS } from '@/assets/static/feedback.static'
   import { useEnvironment } from '@/config'
   const environment = useEnvironment()

   const $storeApp = inject('$storeApp')

   const props = defineProps({
      action: {
         type: String,
         required: true
      },
   })

   // New file form
   const form = reactive({
      subject: SUBJECTS?.[0],
      content: '',
   })

   const waiting = ref(false)
   const sendFeedback = () => {
      waiting.value = true
      $storeApp.sendFeedback(form)
   }

   const feedbackReferenceCode = ref('')
   watch(() => $storeApp.feedbackReferenceCode, reference => {
      feedbackReferenceCode.value = reference
      waiting.value = false
   })

   const eResetFeedback = () => $storeApp.resetFeedback()
</script>

<template>
   <Modal v-if="action == 'feedback'" id="feedback" size="medium">
      <template #header>
         <div class="cg-row-content gap-2">
         <FontAwesomeIcon icon="fas fa-envelope" /> Give Your Feedback
         </div>
      </template>
      <template #body>
         <div v-if="! feedbackReferenceCode" class="cg-column-content">
            <div>
               We value your feedback as it helps us refine and enhance features,
               address any issues, and continuously improve Code Ginnel. Your insights are
               crucial in shaping the future of our platform.
            </div>

            <form @submit.prevent="sendFeedback()" class="cg-column-content" :class=" { saving: waiting } ">

               <div>
                  <v-select v-model="form.subject" :options="SUBJECTS"></v-select>
               </div>

               <div>
                  <label for="feedback-content" class="form-label label-required">Feedback</label>
                  <textarea id="feedback-content" v-model="form.content" class="form-control" rows="6" required></textarea>
               </div>

               <div class="d-flex justify-content-end">
                  <PrimaryButton icon="fas fa-envelope" :disabled=" ! form.content || ! form.subject">
                     <template #label>Send</template>
                     <template #waitingLabel>Sending...</template>
                  </PrimaryButton>
               </div>
            </form>
         </div>

         <div v-else class="text-center">
            <h2 class="text-center">Your Feedback has been sent!</h2>
            <div class="success-icon">
               <i class="fas fa-check-circle"></i>
            </div>
            <div class="my-4 d-flex flex-column align-items-center">
               <p><strong>Your Reference Code: {{ feedbackReferenceCode }}</strong></p>
               <p>A copy of the feedback has been sent to the email address you provided.</p>
               <PrimaryButton @clicked="eResetFeedback" :waiting="waiting ? true : false" type="button" size="sm" icon="fas fa-undo-alt">
                  <template #label>Send More Feedback</template>
               </PrimaryButton>
            </div>
         </div>
      </template>
   </Modal>
</template>